const errorMessages = {
  isNotBoolean: 'Checkbox must have either isChecked or isPartial prop',
  isPartialRadio: 'Radio buttons cannot be partial'
}

interface GenerateErrorProps {
  isChecked?: boolean
  isPartial?: boolean
  type: 'checkbox' | 'radio'
}

export const generateError = ({
  isChecked,
  isPartial,
  type
}: GenerateErrorProps) => {
  if (isChecked === undefined && isPartial === undefined) {
    throw new Error(errorMessages.isNotBoolean)
  }

  if (isPartial !== undefined && type === 'radio') {
    throw new Error(errorMessages.isPartialRadio)
  }
}
